import React from 'react';
import { motion } from 'framer-motion';
import { ScaleSelector } from '../components/ScaleSelector';
import { MolecularBackdrop } from '../components/MolecularBackdrop';
interface Props {
  headline: string;
  answerLabel?: string;
  eyebrow?: string;
  onSelect: (value: number) => void;
  selectedValue?: number;
}
export function SlideBayesian({
  headline,
  answerLabel,
  eyebrow = 'Peer Perception',
  onSelect,
  selectedValue
}: Props) {
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className="flex-1 flex flex-col relative px-5 pt-20 pb-28" data-id="element-459">
      <MolecularBackdrop variant="orbit" data-id="element-460" />

      <div className="relative z-10 flex-1 flex flex-col justify-center items-center text-center" data-id="element-461">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mb-10 w-full" data-id="element-462">
          <span className="text-minerva-blue text-[10px] font-bold tracking-[0.25em] uppercase mb-4 block" data-id="element-463">
            {eyebrow}
          </span>
          <h2 className="text-[22px] font-display font-bold text-slate-900 leading-tight mb-4" data-id="element-464">
            {headline}
          </h2>

          {answerLabel && <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="inline-flex items-center gap-2 mt-1 px-4 py-2 rounded-full bg-minerva-blue/10 border border-minerva-blue/20" data-id="element-465">
              <span className="w-1.5 h-1.5 rounded-full bg-minerva-blue shadow-[0_0_6px_rgba(0,133,189,0.6)]" data-id="element-466" />
              <span className="text-minerva-blue text-sm font-semibold" data-id="element-467">
                {answerLabel}
              </span>
            </motion.div>}
        </motion.div>

        <div className="w-full max-w-sm" data-id="element-468">
          <ScaleSelector onSelect={onSelect} selectedValue={selectedValue} data-id="element-469" />
        </div>
      </div>
    </motion.div>;
}